import React, { useEffect, useState } from "react"
import { formatDateDataGrid } from "src/utils/format-date"
import PropTypes from 'prop-types'
import ParameterPaginationTable from "src/components/table/parameter-pagination-table"
import DatalakeService from "src/services/datalake-service"

// Tabela somente de atualização: não permite criar nem deletar registros.
const ParameterMotorEventosTable = (props) => {
    const dataLakeService = new DatalakeService()
    const [data, setData] = useState([])
    const [pagination, setPagination] = useState({ count: 0, next: null, previous: null })
    // Volta o rodapé da tabela para a página 1 sempre que os dados recarregam a partir do offset 0
    const [resetPaginationKey, setResetPaginationKey] = useState(0)

    useEffect(() => {
        loadData()
    }, [])

    const handleError = (err) => {
        if (props.callbackError) {
            props.callbackError(err)
        }
    }

    const loadData = () => {
        props.loading(true)
        dataLakeService.loadPaginationEndpoint(props.endpoint).then((response) => {
            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))
            setPagination({ count: count, next: next, previous: previous })
            setData(list)
            setResetPaginationKey((key) => key + 1)
        }).catch(handleError).finally(() => {
            props.loading(false)
        })
    }

    const updateRow = async (newRow) => {
        const { ID, IDEvento, TipoEvento, Descricao, Origem, TipoValor, AplicacaoValorNominal, AplicacaoPagamento, AplicacaoJuros, AplicacaoAmortizacao, AntecipaVencimento, CampoMemoriaCalculo, AplicacaoMemoriaCalculo } = newRow

        const body = {
            IDEvento: IDEvento,
            TipoEvento: TipoEvento,
            Descricao: Descricao,
            Origem: Origem,
            TipoValor: TipoValor,
            AplicacaoValorNominal: AplicacaoValorNominal,
            AplicacaoPagamento: AplicacaoPagamento,
            AplicacaoJuros: AplicacaoJuros,
            AplicacaoAmortizacao: AplicacaoAmortizacao,
            AntecipaVencimento: AntecipaVencimento,
            CampoMemoriaCalculo: CampoMemoriaCalculo,
            AplicacaoMemoriaCalculo: AplicacaoMemoriaCalculo
        }

        props.loading(true)
        return dataLakeService.updateTableEndpoint(props.endpoint, ID, body).then(() => {
            props.loading(false)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const onFilter = async (filterList, limit, offset) => {
        const query = filterList.map(obj => `${encodeURIComponent(obj.field)}=${encodeURIComponent(obj.value)}`).join('&')

        props.loading(true)
        dataLakeService.loadPaginationEndpoint(props.endpoint, query, limit, offset).then((response) => {
            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))
            setPagination({ count: count, next: next, previous: previous })
            setData(list)
            setResetPaginationKey((key) => key + 1)
        }).catch(handleError).finally(() => {
            props.loading(false)
        })
    }

    const changePage = async (endpoint) => {
        props.loading(true)
        dataLakeService.paginate(endpoint).then((response) => {
            const { body } = response
            const { results, count, previous, next } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))

            setPagination({ count: count, next: next, previous: previous })
            setData([])
            setData(list)
        }).catch(handleError).finally(() => {
            props.loading(false)
        })
    }

    const columns = [
        {
            field: 'ID',
            headerName: '#',
            disableColumnMenu: true,
            disableFilter: true,
            flex: true,
            minWidth: 80,
        },
        {
            field: 'IDEvento',
            headerName: 'IDEvento',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            type: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'TipoEvento',
            headerName: 'TipoEvento',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'Descricao',
            headerName: 'Descricao',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'Origem',
            headerName: 'Origem',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            type: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'TipoValor',
            headerName: 'TipoValor',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            type: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'AplicacaoValorNominal',
            headerName: 'AplicacaoValorNominal',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            type: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'AplicacaoPagamento',
            headerName: 'AplicacaoPagamento',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            type: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'AplicacaoJuros',
            headerName: 'AplicacaoJuros',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            type: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'AplicacaoAmortizacao',
            headerName: 'AplicacaoAmortizacao',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            type: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'AntecipaVencimento',
            headerName: 'AntecipaVencimento',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            type: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CampoMemoriaCalculo',
            headerName: 'CampoMemoriaCalculo',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            type: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'AplicacaoMemoriaCalculo',
            headerName: 'AplicacaoMemoriaCalculo',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            type: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CriadoEm',
            headerName: 'Data de Criação',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        },
        {
            field: 'AtualizadoEm',
            headerName: 'Data de Atualização',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        }
    ]

    return (
        <div>
            <ParameterPaginationTable
                columns={columns}
                data={data}
                setData={setData}
                useDeleteButton={false}
                updateRow={updateRow}
                filterFunction={onFilter}
                pagination={pagination}
                onChangePage={changePage}
                resetPaginationKey={resetPaginationKey}
                customFilter={true} />
        </div>
    )
}

ParameterMotorEventosTable.propTypes = {
    loading: PropTypes.func,
    endpoint: PropTypes.string,
    callbackError: PropTypes.func,
}

export default ParameterMotorEventosTable